<template>
  <div class="padded">

    <backhaul-table :site-id="site.id" :provider="true" :read-only="readOnly" :site-name="site.siteName" :site-data="site" />

  </div>

</template>


<script>
import SiteMixins from '@/mixins/SiteMixins'

// import BackhaulAction from '@/components/actions/BackhaulAction'
import BackhaulTable from '@/components/backhaul/BackhaulTable'

export default {
  mixins: [SiteMixins],

  components: {
//    BackhaulAction,
    BackhaulTable
  },

  props: {
    rowData: {
      type: Object,
      required: true
    },
    editMode: {
      type: Boolean,
      default: false
    },

    readOnly: {
      type: Boolean,
      default: false
    }

  },
  data () {
    return {
      site: this.rowData
    }
  },

  mounted () {
//    console.log('fin. bh', this.rowData)
  }
}
</script>
